import { Box, Typography } from '@mui/material';
import { TrendingUpIcon } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { InstructionSheetConverter } from './InstructionSheetConverter';
import { LogisticsShippingKpiV2, LogisticsShippingKpiJobsV2 } from './logistics-shipping-kpi-v2';
import type { SimpleAccount } from '@/lib/types';

interface LogisticsShippingKpiProps {
  account: SimpleAccount;
}

export function LogisticsShippingKpi({ account }: LogisticsShippingKpiProps) {
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <TrendingUpIcon size={24} style={{ marginRight: 8 }} />
        倉庫出荷効果検証
      </Typography>

      <Tabs defaultValue="analysis" className="w-full">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="analysis">分析実行</TabsTrigger>
          <TabsTrigger value="logs">実行ログ</TabsTrigger>
          <TabsTrigger value="converter">指示書変換</TabsTrigger>
        </TabsList>

        <TabsContent value="analysis" className="mt-6">
          <LogisticsShippingKpiV2 account={account} />
        </TabsContent>

        <TabsContent value="logs" className="mt-6">
          <LogisticsShippingKpiJobsV2 account={account} />
        </TabsContent>

        <TabsContent value="converter" className="mt-6">
          <InstructionSheetConverter account={account} />
        </TabsContent>
      </Tabs>
    </Box>
  );
}
